import { iNotification, iStoreNotifications } from '@/Interfaces/storeNotifications';
import { defineStore } from 'pinia';
import { setNotificationInvisibleAfterTimeInSeconds } from '../libs/setNotificationInvisibleAfterTimeInSeconds';

export const useStoreNotifications = defineStore('storeNotifications', {
    state: () => ({
        notifications: [
            // {
            //     id: '1855846c-1fa1-4b62-92c8-e7a5c7f02cc0',
            //     type: 'projectSaved',
            //     text: 'Проект сохранён!',
            //     visible: true,
            // },
        ],
    } as iStoreNotifications),
    getters: {
        getNotificationById: (state) => {
            return (id: string) => {
                return state.notifications
                    .find(item => item.id === id);
            };
        },
        getLastNotification: (state) => {
            return state.notifications[state.notifications.length - 1];
        },
    },
    actions: {
        addNotification(value: iNotification, timeout?: number | undefined) {
            this.notifications.push(value);
            if (timeout) {
                setNotificationInvisibleAfterTimeInSeconds(value.id, timeout);
            }
        },
        deleteNotificationById(id: string) {
            this.notifications = this.notifications
                .filter(item => item.id !== id);
        },
        setNotificationVisibleById(id: string, status: boolean) {
            const notification = this.notifications
                .find(item => item.id === id);

            if (!notification) {
                return;
            }

            notification.visible = status;
        },
    },
});
